import { HelpButton } from "@certn/auth";
import { PrimaryTopNav, Space } from "@certn/cascadia-react";
import { useNavigate } from "react-router-dom";

import { AppLogo } from "./AppLogo";
import { SettingsDropdown } from "./SettingsDropdown";
import { Branding } from "./types";
import { useUser } from "../../hooks/api/useUser";

interface Props {
  hideSettings?: boolean;
  showLoginButton?: boolean;
  branding?: Branding;
}

export function AppHeader({ showLoginButton, hideSettings, branding }: Props) {
  const navigate = useNavigate();
  const { details: userDetails } = useUser();

  return (
    <PrimaryTopNav
      testID="applicant-portal-top-nav"
      logo={<AppLogo branding={branding} />}
      onLogoPress={() =>
        userDetails ? navigate("/") : (location.href = "https://certn.co/")
      }
    >
      <Space />
      <HelpButton />
      {!hideSettings && <SettingsDropdown />}
    </PrimaryTopNav>
  );
}
